import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useI18n } from '@haohan/root-locales';
import { locales } from './config';

const useStyles = makeStyles({name: "SiteHeaderLanguages"})(theme => ({
	flagItem: {
		width: 28,
		height: 28,
		borderRadius: "50%",
		overflow: "hidden",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		boxShadow: theme.shadows[3],
		boxSizing: "border-box",
		cursor: "pointer",
		backgroundClip: "content-box",
		backgroundSize: "cover",
		border: `1px solid transparent`,
		backgroundPosition: "center center",
		opacity: .2,
		margin: "0 4px",
	},
	flagItemActive: {
		opacity: 1,
		padding: 1,
		borderColor: theme.palette.primary.light
	}
}));

export function SiteLanguages() {
    const { lang } = useI18n();
    const location = useLocation();
    const { classes, cx } = useStyles();
    const locationUrl = (newLang: string) => {
		const newPathname = location.pathname.replace(
			new RegExp(`^/${lang}(.*)`),
			`/${newLang}$1`
		);

		return `${newPathname}${location.search}`;
	}
    return (
        <Box display="flex" flexWrap="nowrap">
            {locales.map(l => {
                return (
                    <a
                        key={l.locale}
						aria-label={l.locale}
                        href={locationUrl(l.locale)}
                    >
                        <Box
                            className={cx(classes.flagItem, {
                                [classes.flagItemActive]: l.locale === lang
                            })}
                            style={{ backgroundImage: `url(${l.flag})` }}
                            key={l.locale}
                        />
                    </a>
                );
            })}
        </Box>
    );
}
